<p-toast></p-toast>
<div class="flex flex-column gap-2 p-1 m-1">
  <div class="flex flex-row flex-wrap mb-2">
    <button pButton type="button" label="Bulk Update Names from OLS" icon="pi pi-refresh"
      (click)="bulkUpdateCvParameterNames()" [loading]="bulkUpdating" [disabled]="bulkUpdating"></button>
  </div>
  <app-crud-table [title]="'Cv Parameters'" [columns]="columns" [filterFields]="filterFields" [crudAdapter]="crudAdapter"></app-crud-table>
</div>
